/** Address + date fields that must be filled before a trade can be saved. */
export const TRADE_KEY_INFO_REQUIRED_FIELDS = [
  { key: "streetNumber", label: "Street #" },
  { key: "streetName", label: "Street Name" },
  { key: "city", label: "City" },
  { key: "province", label: "Province" },
  { key: "postalCode", label: "Postal Code" },
  { key: "offerDate", label: "Offer Date" },
  { key: "closeDate", label: "Close Date" },
  { key: "entryDate", label: "Entry Date" },
];

export function getMissingTradeKeyInfoFields(keyInfo = {}) {
  return TRADE_KEY_INFO_REQUIRED_FIELDS.filter(
    ({ key }) => !String(keyInfo?.[key] ?? "").trim(),
  );
}

export function formatMissingTradeKeyInfoMessage(missing) {
  if (!missing?.length) return "";
  return `Please fill in required fields: ${missing
    .map((m) => m.label)
    .join(", ")}`;
}
